const COMBINED_BOULDER_REGEX = /CLB.BLCOMB------------((SFNL)|(FNL-))0001.+/

const COMBINED_LEAD_REGEX = /CLB.BLCOMB------------((SFNL)|(FNL-))0002.+/

const SPEED_SEED_REGEX = /CLB.SPEED-------------QUAL0001SD.+/

const SPEED_QUAL_REGEX = /CLB.SPEED-------------QUAL0002EL.+/

const SPEED_FNL_REGEX = /CLB.SPEED-------------((.FNL)|(FNL.)).+/

const BOULDER_KRA_REGEX = /CLB.BOULDER.+/

const LEAD_QUAL_KRA_REGEX = /CLB.LEAD.+/

const QUAL_REGEX = /CLB...................QUAL..+/

const SEMIS_REGEX = /CLB...................SFNL..+/

const FINALS_REGEX = /CLB...................FNL-..+/

export const isCombinedBoulder = (rsc) => {
    return COMBINED_BOULDER_REGEX.test(rsc);
}

export const isCombinedLead = (rsc) => {
    return COMBINED_LEAD_REGEX.test(rsc);
}

export const isSpeedSeeding = (rsc) => {
    return SPEED_SEED_REGEX.test(rsc);
}

export const isSpeedQualification = (rsc) => {
    return SPEED_QUAL_REGEX.test(rsc);
}

export const isSpeedFinal = (rsc) => {
    return SPEED_FNL_REGEX.test(rsc);
}

export const isBoulderKRA = (rsc) => {
    return BOULDER_KRA_REGEX.test(rsc);
}

export const isLeadKRA = (rsc) => {
    return LEAD_QUAL_KRA_REGEX.test(rsc);
}

export const isQual = (rsc) => {
    return QUAL_REGEX.test(rsc);
}

export const isSemis = (rsc) => {
    return SEMIS_REGEX.test(rsc);
}

export const isFinals = (rsc) => {
    return FINALS_REGEX.test(rsc)
}



